export const lightApp = 'LIGHT-APP';
export const djiApp = 'DJI-APP';
export const mimoApp = 'MIMO-APP';
export const flyApp = 'FLY-APP';
export const wechat = 'WECHAT';
export const weibo = 'WEIBO';
export const qqBrowser = 'QQ-BROWSER';
